import "./About.css";
import { toPersianNumber } from "../../classes/utils";

const About = (props) => {
    let { mobile, phone, zip, address } = props.contact_info || {};
    return (
        <div className="AboutComponent">
            <div className="container">
                <h1 className="text primary">درباره ما</h1>
                <p>
                    فروشگاه خرازی نیکا(خرازی یکتا سابق) فعالیت خودرا از سال ۱۴۰۰
                    درزمینه فروش لوازم خرازی و تهیه و توزیع پارچه های برزنت و
                    یراق تخصصی دوخت انواع کیف و کوله پشتی در فضای مجازی آغاز
                    نموده است و درنهایت برآن شد که فروش اینترنتی را در فضایی امن
                    و با بهترین کیفیت و مناسب ترین قیمت و امکانات درقالب سایت
                    ارائه نماید. در خرازی نیکا میتوانید انواع لوازم تخصصی دوخت
                    کیف و کوله پشتی مدارس ،ساک و چمدان های مسافرتی و انواع پارچه
                    های برزنتی ومخمل با کیفیت های عالی و متناسب باهر سن و سلیقه
                    ای رو تهیه کنید. تمام تلاشمون رو میکنیم که لوازم رو بامناسب
                    ترین قیمت ها و بهترین کیفیت و در سریعترین زمان ممکن به دست
                    شما عزیزان برسانیم.
                </p>
                <p className="text secondary">تلفن پشتیبانی ۰۹۰۳۷۳۷۵۸۸۲</p>
                <p className="text secondary">بامدیریت آقای بهرامی</p>
                {mobile && (
                    <p className="info text secondary">
                        <div className="name text info ">{"موبایل "}</div>
                        {toPersianNumber(mobile)}
                    </p>
                )}
                {phone && (
                    <p className="info text secondary">
                        <div className="name text info ">{"تلفن "}</div>
                        {toPersianNumber(phone)}
                    </p>
                )}
                {address && (
                    <p className="info text secondary">
                        <div className="name text info ">{"آدرس "}</div>
                        {toPersianNumber(address)}
                    </p>
                )}
                {zip && (
                    <p className="info text secondary">
                        <div className="name text info ">{"کدپستی "}</div>

                        {toPersianNumber(zip)}
                    </p>
                )}
                <p className="info text secondary">
                    <div className="name text info ">
                        {"پیج ایسنتاگرام     "}
                    </div>
                    <a href="https://www.instagram.com/kharazie_nika/">
                        خرازی نیکا (یکتا سابق)
                    </a>
                </p>
                <p className="info text secondary">
                    <div className="name text info ">{"کانال ایتا     "}</div>
                    <a href="https://eitaa.com/kharazienika">
                        خرازی نیکا (یکتا سابق)
                    </a>
                </p>
            </div>
        </div>
    );
};

export default About;
